import { render, staticRenderFns } from "./PieChartV2.vue?vue&type=template&id=c0bc4a84&scoped=true&"
import script from "./PieChartV2.vue?vue&type=script&lang=js&"
export * from "./PieChartV2.vue?vue&type=script&lang=js&"
import style0 from "./PieChartV2.vue?vue&type=style&index=0&id=c0bc4a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bc4a84",
  null
  
)

export default component.exports